import { CDIPreQueryAlert } from "../types/cdi-alerts";

export const extractCDIAlertsV2 = (payload: any): CDIPreQueryAlert[] => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.alerts)) {
    return payload.alerts;
  }

  return [];
};

export const normalizeCDIAlertStatus = (status?: string) =>
  status?.trim()?.toUpperCase?.() || "";
